import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateYSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M45.43,17.48V66h-14V40.16c0-3.95-15.53-10.19-15.53-15.32V17.48Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M43.66,81.79v7.36H14.16V40.6h14V66.48C28.13,70.42,43.66,76.66,43.66,81.79Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M88.72,24l-2.07,2.36a17.77,17.77,0,1,0-17.26,22,1.33,1.33,0,1,0,0-2.66A15.12,15.12,0,1,1,83.75,25.87L82.1,24.43l.26,3.8,3.52,3.08L89,27.79Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M35.77,72.24c-2.75-1.9-6.51-4.51-6.51-5.76V40.6a1.14,1.14,0,0,0-1.13-1.13h-14a1.13,1.13,0,0,0,0,2.25H27V66.48c0,2.43,3.3,4.71,7.49,7.61,3.58,2.47,8,5.56,8,7.7V88H14.16a1.12,1.12,0,1,0,0,2.24h29.5a1.12,1.12,0,0,0,1.12-1.12V81.79C44.78,78.47,40.2,75.3,35.77,72.24Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M45.43,18.6a1.12,1.12,0,0,0,0-2.24H15.93a1.12,1.12,0,0,0-1.12,1.12v7.36c0,3.32,4.58,6.49,9,9.55,2.75,1.9,6.51,4.51,6.51,5.77V66a1.13,1.13,0,0,0,1.13,1.12h14a1.12,1.12,0,0,0,0-2.24H32.58V40.16c0-2.44-3.3-4.72-7.49-7.62-3.58-2.47-8-5.56-8-7.7V18.6Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-highlight",
			points: "82.51 33.86 78.72 40.09 74.97 33.86 71.08 33.86 76.86 43.44 76.86 48.61 80.42 48.61 80.42 43.4 86.19 33.86 82.51 33.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,59.19a1.34,1.34,0,0,0-1.33,1.33v3.32a1.33,1.33,0,0,0,2.66,0V60.52A1.33,1.33,0,0,0,14.16,59.19Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,52.55a1.34,1.34,0,0,0-1.33,1.33V57.2a1.33,1.33,0,0,0,2.66,0V53.88A1.33,1.33,0,0,0,14.16,52.55Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,39.27a1.33,1.33,0,0,0-1.33,1.33v3.32a1.33,1.33,0,0,0,2.66,0V40.6A1.32,1.32,0,0,0,14.16,39.27Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,45.91a1.33,1.33,0,0,0-1.33,1.33v3.32a1.33,1.33,0,0,0,2.66,0V47.24A1.32,1.32,0,0,0,14.16,45.91Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,79.12a1.33,1.33,0,0,0-1.33,1.33v3.32a1.33,1.33,0,1,0,2.66,0V80.45A1.32,1.32,0,0,0,14.16,79.12Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,85.76a1.34,1.34,0,0,0-1.33,1.33v2.06a1.33,1.33,0,0,0,2.66,0V87.09A1.33,1.33,0,0,0,14.16,85.76Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,72.47a1.34,1.34,0,0,0-1.33,1.33v3.33a1.33,1.33,0,0,0,2.66,0V73.8A1.33,1.33,0,0,0,14.16,72.47Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M14.16,65.83a1.34,1.34,0,0,0-1.33,1.33v3.32a1.33,1.33,0,1,0,2.66,0V67.16A1.33,1.33,0,0,0,14.16,65.83Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,61.39a1.32,1.32,0,0,0-1.33,1.33V66a1.33,1.33,0,1,0,2.66,0V62.72A1.33,1.33,0,0,0,45.43,61.39Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,21.54a1.32,1.32,0,0,0-1.33,1.33v3.32a1.33,1.33,0,1,0,2.66,0V22.87A1.33,1.33,0,0,0,45.43,21.54Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,16.15a1.32,1.32,0,0,0-1.33,1.33v2.07a1.33,1.33,0,1,0,2.66,0V17.48A1.33,1.33,0,0,0,45.43,16.15Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,28.18a1.32,1.32,0,0,0-1.33,1.33v3.32a1.33,1.33,0,0,0,2.66,0V29.51A1.33,1.33,0,0,0,45.43,28.18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,41.46a1.33,1.33,0,0,0-1.33,1.33v3.32a1.33,1.33,0,0,0,2.66,0V42.79A1.34,1.34,0,0,0,45.43,41.46Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,48.1a1.33,1.33,0,0,0-1.33,1.33v3.32a1.33,1.33,0,1,0,2.66,0V49.43A1.34,1.34,0,0,0,45.43,48.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,34.82a1.33,1.33,0,0,0-1.33,1.33v3.32a1.33,1.33,0,0,0,2.66,0V36.15A1.34,1.34,0,0,0,45.43,34.82Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45.43,54.75a1.32,1.32,0,0,0-1.33,1.33V59.4a1.33,1.33,0,0,0,2.66,0V56.08A1.33,1.33,0,0,0,45.43,54.75Z"
		})
	]
});
export default SvgRotateYSm;
